module.exports = __webpack_public_path__ + "img/logo-guide.e2a33459.png";